<script>

import Vue from 'vue';

export default {
    name: "ExportExcel",
    props: {
        data: {
            type: Array,
            required: true
        },
        filtre:{
            type: Object,
            required: false,
        },
        link: {
            type: String,
            required: true,
        },
        cible: {
            type: String,
            default: 'CI'
        }
    },
    data() {
        return {
            checkedItems: [],
            base_url_laravel: Vue.BASE_URL_LARAVEL,
        }
    },
    methods: {
        toggleAll(event) {
            const isChecked = event.target.checked;
            if (isChecked) {
                this.checkedItems = this.data
                    .filter(item => item.is_excel != 'false')
                    .map(item => ({
                        header: item.title,
                        value: item.name
                    }));
            } else {
                this.checkedItems = [];
            }
        },

        toggleItem(item) {
            const index = this.checkedItems.findIndex(checkedItem => checkedItem.value === item.name);
            if (index > -1) {
                this.checkedItems.splice(index, 1);
            } else {
                this.checkedItems.push({ header: item.title, value: item.name });
            }
        },

        async gotoExport() {
            const queryString = new URLSearchParams({
                data: JSON.stringify(this.checkedItems),
                token: localStorage.getItem("token"),
            }).toString();
            const queryFiltre = new URLSearchParams(this.filtre).toString();
            const fullQuery = `${queryString}&${queryFiltre}`;

            if (this.cible == 'CI') {
                const fullLink = this.BASE_URL + this.link;
                window.open(fullLink + "?" + fullQuery, '_blank');
            } else {
                const fullLink = this.base_url_laravel+this.link
                window.open(fullLink + "?" + fullQuery, '_blank');
            }
        },

        gotoExports() {
            const queryString = new URLSearchParams({
                data: JSON.stringify(this.checkedItems),
                token:  localStorage.getItem("token"),
            }).toString();
            const queryFiltre = new URLSearchParams(this.filtre).toString();
            const fullQuery = `${queryString}&${queryFiltre}`;
            const fullLink = this.BASE_URL+this.link;
            window.open(fullLink + "?" + fullQuery, '_blank');

        }
    }
}
</script>

<template>
    <div class="btn-group ml-1">
        <button style="border-radius: 0!important;" class="btn btn-secondary btn-sm dropdown-toggle rounded-0" type="button" data-toggle="dropdown"
                aria-expanded="false">
            Exporter le tableau
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" v-on:click.stop>
            <table class="table_dropdown">
                <tr>
                    <td>
                        <input class="form-check-input" type="checkbox" id="form-check-all" @change="toggleAll">
                        <label class="form-check-label" for="form-check-all">Tout cochez</label>
                    </td>
                </tr>
                <tr v-for="(u, index) in data" :key="index">
                    <td v-if="u.is_excel != 'false'">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            :id="u.name"
                            :value="u.name"
                            @change="toggleItem(u)"
                            :checked="checkedItems.some(item => item.value === u.name)">
                        <label class="form-check-label" :for="u.name">{{ u.title }}</label>
                    </td>
                </tr>
            </table>
            <div class="dropdown-divider"></div>
            <button @click="gotoExport" class="btn btn-sm w-100 btn-outline-dark">Exporter</button>
        </div>
    </div>
</template>

<style scoped>
.table_dropdown tr td {
    padding-left: 30px !important;
    padding-top: 5px !important;
}

.dropdown-divider {
    margin-bottom: 0 !important;
}
</style>

